import exists from '../tools/exists';

// Global Components
import('./geo-location');
import('./footer-menu');
import('./header-menu');
import('./header-search');
import('./modal');
import('./myaccount-video');
import('./checkout');
import('./checkout-upsell');
import('./live-chat');
import('./language-bar');

if (
    exists('[data-behaviour*="addiction-change"]') ||
    exists('[data-behaviour="login-ajax"]') ||
    exists('[data-behaviour="register-ajax"]')
) {
    import('./seminar');
}

if (exists('[data-behaviour*="ovp-tracking-video"]')) {
    import('./ovp');
}

if (exists('[data-behaviour="open-faq"]')) {
    import('./frequently-asked-questions');
}

if (exists('[data-behaviour="open-faq"]')) {
    import('./frequently-asked-questions');
}

if (exists('.gravity-form-sections')) {
    import('./gravity-form-sections');
}

if (exists('[data-behaviour="check-availability"]')) {
    import('./product-availability-checker');
}

if (exists('[data-behaviour="show-references"]')) {
    import('./block-references');
}

if (
    exists('[data-behaviour="articles-slider"]') ||
    exists('[data-behaviour="choose-programme-slider"]') ||
    exists('[data-behaviour="testimonial-slider"]') ||
    exists('[data-behaviour="choose-addiction-slider"]') ||
    exists('[data-behaviour="video-slider"]') ||
    exists('[data-behaviour="carousel-slider-layout_1"]') ||
    exists('[data-behaviour="carousel-slider-layout_2"]') ||
    exists('[data-behaviour="carousel-slider-layout_3"]')
) {
    import('./sliders');
}

if (exists('[data-behaviour="copy-link"]')) {
    import('./copy-to-clipboard');
}

if (
    exists('[data-select="styled"], .ginput_address_country select') ||
    exists('[data-reorder="true"]') ||
    exists('[data-behaviour="dropdown-trigger"]')
) {
    import('./dropdown');
}

if (exists('[data-behaviour="tabs"]') || exists('[data-tabs]')) {
    import('./tabs');
}

if (exists('[data-behaviour="rating-field"]')) {
    import('./rating-field');
}

if (exists('[data-behaviour="addiction-field"]')) {
    import('./addiction-field');
}

if (exists('[data-behaviour="image-upload"]')) {
    import('./image-upload-field');
}

if (exists('[data-behaviour="video-upload"]')) {
    import('./video-upload-field');
}

if (exists('.gform-accordion')) {
    import('./form-section-accordion');
}

if (exists('[data-opening-time]')) {
    import('./location-online-checker');
}

if (
    exists('[data-accordion="container"]') ||
    exists('[data-accordion-container="ovp-container"]')
) {
    import('./accordion');
}

if (exists('[data-behaviour*="validate-form"]')) {
    import('./form-validation');
}

if (exists('[data-ref="choose-programme-carousel-slider"]')) {
    import('./block-choose-programme');
}

if (exists('[data-behaviour="close-notice"]')) {
    import('./notice-block');
}

if (exists('[data-behaviour="scrollable-table"]')) {
    import('./scrollable-table');
}

if (exists('[data-behaviour="countdown-timer"]')) {
    import('./countdown-timer');
}

if (exists('[data-behaviour*="toggle-view-all"]')) {
    import('./view-all');
}

if (exists('[data-behaviour*="content-toggle"]')) {
    import('./toggle');
}

if (exists('body a:not(.wpml-ls-link)')) {
    import('./wpml-fix');
}

if (exists('[data-ref="programme-selects"]') || exists('[data-ref="compare-selects"]')) {
    import('./comparison-table');
}

if (exists('[data-target="sticky-cta"]')) {
    import('./sticky-cta');
}

if (exists('.button')) {
    import('./buttons');
}
